export const getCaptureHigherEdTrackingId = state =>
  state.account.captureHigherEdTrackingId;

export const getPermissions = state => state.account.permissions;
